import { createContext } from 'react';
import type { LayoutContextProps } from '../../../Models/Template';

export const LayoutContext = createContext({} as LayoutContextProps);
